/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModSavedFilters: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M7.41442 5.587L8.99942 7.172L9.08542 7.087V7L13.7834 1.519C14.4994 0.684 14.1924 0 13.0914 0H1.07942C-0.0205796 0 -0.33158 0.68 0.38742 1.519L4.25842 6.035C4.34842 5.874 4.45242 5.72 4.58642 5.586C4.96342 5.209 5.46542 5 6.00042 5C6.53442 5 7.03642 5.209 7.41442 5.587Z' />
			<path d='M7.58532 11.4131L5.08532 8.9131V11.9031C5.08532 12.4471 5.40132 13.2161 5.79132 13.6051L7.67532 15.4901C8.45132 16.2671 9.08532 16.0011 9.08532 14.8921V11.9921C9.07191 11.9926 9.05872 11.9943 9.04554 11.996C9.03022 11.9981 9.01491 12.0001 8.99932 12.0001C8.46532 12.0001 7.96332 11.7921 7.58532 11.4131Z' />
			<path d='M14.2924 3.293C14.6844 2.902 15.3154 2.902 15.7064 3.293C16.0984 3.685 16.0984 4.316 15.7064 4.707L9.70642 10.707C9.51242 10.902 9.25542 11 8.99942 11C8.74342 11 8.48742 10.902 8.29242 10.707L5.29242 7.707C4.90142 7.316 4.90142 6.685 5.29242 6.293C5.68442 5.902 6.31542 5.902 6.70642 6.293L8.99942 8.586L14.2924 3.293Z' />
		</Svg>
	);
};

export { ModSavedFilters };
